export interface ResolveValidationStateParams<TErrorMessage> {
  isInvalid?: boolean;
  errorMessage?: TErrorMessage;
  fieldName?: string;
  validationErrors?: Record<string, unknown>;
}

export interface ResolveValidationStateResult<TErrorMessage> {
  effectiveErrorMessage: TErrorMessage | string | undefined;
  effectiveIsInvalid: boolean | undefined;
}

export function resolveValidationState<TErrorMessage>({
  isInvalid,
  errorMessage,
  fieldName,
  validationErrors,
}: ResolveValidationStateParams<TErrorMessage>): ResolveValidationStateResult<TErrorMessage> {
  const mappedError = fieldName ? validationErrors?.[fieldName] : undefined;
  const mappedErrorMessage = Array.isArray(mappedError)
    ? mappedError[0]
    : mappedError;
  const hasMappedError =
    typeof mappedErrorMessage === 'string' && mappedErrorMessage.length > 0;

  let mappedStringErrorMessage: string | undefined;
  if (typeof mappedErrorMessage === 'string') {
    mappedStringErrorMessage = mappedErrorMessage;
  }

  const effectiveErrorMessage = errorMessage ?? mappedStringErrorMessage;

  let effectiveIsInvalid: boolean | undefined;
  if (typeof isInvalid === 'boolean') {
    effectiveIsInvalid = isInvalid;
  } else if (hasMappedError) {
    effectiveIsInvalid = true;
  }

  return {
    effectiveErrorMessage,
    effectiveIsInvalid,
  };
}
